import { render, staticRenderFns } from "./nav-header-lg.vue?vue&type=template&id=0837ad46&scoped=true"
import script from "./nav-header-lg.vue?vue&type=script&lang=js"
export * from "./nav-header-lg.vue?vue&type=script&lang=js"
import style0 from "./nav-header-lg.vue?vue&type=style&index=0&id=0837ad46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0837ad46",
  null
  
)

export default component.exports